import { LocalStorageRemoteAuthSessionRepository, RemoteAppAuthService } from '@prodcard/core-web-app'
import { httpClient } from './remote'
import { MockedDBConnection } from '@prodcard/core'
import { translationService } from './translation'
import { usersService } from './users'
import { rolesService } from './roles'
import { permissionsService } from './permissions'

const remoteAuthSessionRepository = new LocalStorageRemoteAuthSessionRepository('authSession')

export const authService = new RemoteAppAuthService({
  httpClient,
  rolesService: rolesService,
  usersService: usersService,
  translationService,
  dbConnection: new MockedDBConnection(),
  remoteAuthSessionRepository: remoteAuthSessionRepository,
})
permissionsService.authService = authService
